import React from 'react';

import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import FromToDatePicker from '../../../../components/Common/FromToDatePicker';
import { trans } from '../../../../localization/index';
import { getPermissionRestaurant } from '../../../../utils/utils';
import { EnumMerchantPermission, EnumReportTimeFilterType, genEnumToOption } from '../../../../constants/enum';

class ExportRestaurantFilter extends React.Component {
  restaurantOptions = [
    {
      value: 0,
      label: trans('mod_all_restaurant'),
    },
    ...getPermissionRestaurant(
      this.props.restaurants,
      EnumMerchantPermission.REPORT_ALL.id,
    ).map(res => ({
      value: res.restaurant_id,
      label: res.is_use_partner_app ? (
        <div className="choose-restaurant-modal-option">
          {res.name}
          <div className="choose-restaurant-modal-option-tag">
            {trans('merchant_transfer_simpleDialog_text_transferred')}
          </div>
        </div>
      ) : res.name,
    })),
  ];

  reportTimeFilterTypeOptions = genEnumToOption(EnumReportTimeFilterType);

  handleChangeRestaurant = (value) => {
    const { filters, handleChangeFilters } = this.props;
    const { restaurant } = filters;
    if (value === null || value.value !== restaurant.value) {
      handleChangeFilters('restaurant', value);
    }
  };

  handleChangeShowAllFilters = (value) => {
    const { handleChangeFilters, handleSearch } = this.props;
    handleChangeFilters('isShowTotal', value);
    if (value) {
      handleChangeFilters('restaurant', this.restaurantOptions[0]);
      handleSearch();
    }
  };

  handleChangeTimeFilterType = (value) => {
    const { handleChangeFilters } = this.props;
    handleChangeFilters('timeFilterType', value);
  };

  render() {
    const { filters, handleChangeFilters, requestOrderReport } = this.props;
    const { restaurant, fromDate, toDate, timeFilterType } = filters;
    return (
      <FilterWrapper>
        <InputWrapper label={trans('mod_restaurant_list')} width={300}>
          <NowSelect
            value={restaurant}
            options={this.restaurantOptions}
            onChange={this.handleChangeRestaurant}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_filter_time')} width={300}>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date => handleChangeFilters('fromDate', date)}
            handleChangeToDate={date => handleChangeFilters('toDate', date)}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_time_filter_type')} width={250}>
          <NowSelect
            value={timeFilterType}
            options={this.reportTimeFilterTypeOptions}
            onChange={this.handleChangeTimeFilterType}
          />
        </InputWrapper>
        <InputWrapper>
          <button
            type="button"
            className="btn btn-red border"
            onClick={requestOrderReport}
          >
            {trans('mod_filter_export')}
          </button>
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

export default ExportRestaurantFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ExportRestaurant/components/ExportRestaurantFilter.jsx